import { REHYDRATE } from 'redux-persist';
import {
  LEADS_FETCH,
  LEADS_FETCH_BY_ID,
  LEADS_INCIDENT_PIE_CHART,
  LEADS_SET_FILTERS
} from '../actions';

const INIT_STATE = {
  list: [],
  list_paging: { total_rows: 0, page_size: 25, page_indx: 0 },
  lead: null,
  incident_chart: null,
  grid_options: {
    lead: {
      crud_modal: null,
      crud_data: null,
      view: 'list',
      sort: 'asc',
      search: null,
      filters: {
      }
    }
  },
};

const handler = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LEADS_FETCH.SUCCESS: {
      const total = action.payload.length
      return { ...state, list: action.payload, list_paging: { total_rows: total, page_size: total, page_indx: 1 } }
    }
    case LEADS_FETCH_BY_ID.SUCCESS: {
      return { ...state, lead: action.payload }
    }
    case LEADS_INCIDENT_PIE_CHART.SUCCESS: {
      return { ...state, incident_chart: action.payload }
    }
    case LEADS_SET_FILTERS.REQUEST: {
      const key = 'lead'
      return { ...state, grid_options: {
        ...state.grid_options,
        [key]: {
          ...state.grid_options[key],
          filters: {
            ...state.grid_options[key].filters,
            ...action.payload,
          }
        },
      } }
    }
    case REHYDRATE: {
      return INIT_STATE
    }
    default: return { ...state };
  }
}

export default handler
